export const FIELD_NAMES = {
  MAIN_REASON: 'mainReason',
  REWARDS: 'rewardsExperience',
  ORDER_METHOD: 'orderMethod',
  DEVICE_USED: 'deviceUsed',
  ORDER_DATE: 'orderDate',
  ORDER_TIME: 'orderTime',
  STORE_LOCATION: 'storeLocation',
  AMOUNT_SPENT: 'amountSpent',
  SHARED_FEEDBACK: 'sharedFeedback',
  RESPONSE_METHOD: 'responseMethod',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  EMAIL: 'email',
  CONFIRM_EMAIL: 'confirmEmail',
  PHONE: 'phone'
};

export const CONTACT_FORM_STATES = {
  DEFAULT: 'default',
  COLLECTING_ORDER_METHOD: 'collecting_order_method',
  COLLECTING_REWARDS_EXPERIENCE: 'collecting_rewards_experience',
  COLLECTING_GENERAL_INQUIRY: 'collecting_general_inquiry',
  COLLECTING_ORDER_DATA: 'collecting_order_data',
  COLLECTING_CONTACT_INFORMATION: 'collecting_contact_information'
} as {
  [key: string]: ContactFormStates;
};

export const FieldsByState = {
  [CONTACT_FORM_STATES.DEFAULT]: [
    FIELD_NAMES.MAIN_REASON
  ],
  [CONTACT_FORM_STATES.COLLECTING_ORDER_METHOD]: [
    FIELD_NAMES.MAIN_REASON,
    FIELD_NAMES.ORDER_METHOD
  ],
  [CONTACT_FORM_STATES.COLLECTING_ORDER_METHOD]: [
    FIELD_NAMES.MAIN_REASON,
    FIELD_NAMES.REWARDS,
    FIELD_NAMES.ORDER_METHOD
  ],
  [CONTACT_FORM_STATES.COLLECTING_REWARDS_EXPERIENCE]: [
    FIELD_NAMES.MAIN_REASON,
    FIELD_NAMES.REWARDS
  ],
  [CONTACT_FORM_STATES.COLLECTING_GENERAL_INQUIRY]: [
    FIELD_NAMES.MAIN_REASON,
    FIELD_NAMES.STORE_LOCATION,
    FIELD_NAMES.SHARED_FEEDBACK
  ],
  [CONTACT_FORM_STATES.COLLECTING_ORDER_DATA]: [
    FIELD_NAMES.MAIN_REASON,
    FIELD_NAMES.REWARDS,
    FIELD_NAMES.ORDER_METHOD,
    FIELD_NAMES.DEVICE_USED,
    FIELD_NAMES.ORDER_DATE,
    FIELD_NAMES.ORDER_TIME,
    FIELD_NAMES.STORE_LOCATION,
    FIELD_NAMES.AMOUNT_SPENT,
    FIELD_NAMES.SHARED_FEEDBACK,
    FIELD_NAMES.RESPONSE_METHOD
  ],
  [CONTACT_FORM_STATES.COLLECTING_CONTACT_INFORMATION]: [
    FIELD_NAMES.MAIN_REASON,
    FIELD_NAMES.REWARDS,
    FIELD_NAMES.ORDER_METHOD,
    FIELD_NAMES.DEVICE_USED,
    FIELD_NAMES.ORDER_DATE,
    FIELD_NAMES.ORDER_TIME,
    FIELD_NAMES.STORE_LOCATION,
    FIELD_NAMES.AMOUNT_SPENT,
    FIELD_NAMES.SHARED_FEEDBACK,
    FIELD_NAMES.RESPONSE_METHOD,
    FIELD_NAMES.FIRST_NAME,
    FIELD_NAMES.LAST_NAME,
    FIELD_NAMES.EMAIL,
    FIELD_NAMES.CONFIRM_EMAIL,
    FIELD_NAMES.PHONE
  ]
};

export const SupportedFormItems = {
  SELECT: 'select',
  INPUT: 'input',
  TEXTAREA: 'textarea',
  DATE_PICKER: 'date'
} as {
  [key: string]: ContactFormSupportedFormItems;
};

export const PHONE_PATTERN = '^[0-9]{10}$'; // 10 digits, no special characters
export const EMAIL_PATTERN = '^[^@]+@[^@]+.[^@]+$'; // simple email pattern
export const SPENT_AMOUNT_PATTERN = '^[0-9]+(.[0-9]{1,2})?$'; // positive number with decimal up to 2 places
export const REWARDS_EXPERIENCE_OPTION_VALUE = 'Rewards Experience';
export const ONLINE_CARRYOUT_OPTION_VALUE = 'Online Carryout';
export const ONLINE_DELIVERY_OPTION_VALUE = 'Online Delivery';

export const RESPONSE_METHODS = {
  EMAIL: 'Email',
  PHONE: 'Phone',
  NO_REPLY_NEEDED: 'No reply needed'
} as const;

export const fields = [
  {
    name: 'mainReason',
    label: 'What would you like to tell us about?',
    type: SupportedFormItems.SELECT,
    options: [
      {
        value: 'Restaurant/Food Experience',
        label: 'Restaurant/Food Experience',
        fieldset: CONTACT_FORM_STATES.COLLECTING_ORDER_METHOD
      },
      {
        value: 'Website/Mobile Experience',
        label: 'Website/Mobile Experience',
        fieldset: CONTACT_FORM_STATES.COLLECTING_ORDER_METHOD
      },
      {
        value: 'Both Rest and Online Experience',
        label: 'Both Rest and Online Experience',
        fieldset: CONTACT_FORM_STATES.COLLECTING_ORDER_METHOD
      },
      {
        value: 'Gluten Free',
        label: 'Gluten Free',
        fieldset: CONTACT_FORM_STATES.COLLECTING_ORDER_METHOD
      },
      {
        value: REWARDS_EXPERIENCE_OPTION_VALUE,
        label: 'Rewards Experience',
        fieldset: CONTACT_FORM_STATES.COLLECTING_REWARDS_EXPERIENCE
      },
      {
        value: 'General Inquiry',
        label: 'General Inquiry',
        fieldset: CONTACT_FORM_STATES.COLLECTING_GENERAL_INQUIRY
      }
    ],
    required: true
  },
  {
    name: 'rewardsExperience',
    label: 'What do you need help with?',
    type: SupportedFormItems.SELECT,
    options: [
      {
        value: 'Acct Access Issues',
        label: 'Acct Access Issues',
        fieldset: CONTACT_FORM_STATES.COLLECTING_ORDER_DATA
      },
      {
        value: 'Can not Redeem Pts',
        label: 'Can not Redeem Pts',
        fieldset: CONTACT_FORM_STATES.COLLECTING_ORDER_DATA
      },
      {
        value: 'Delete Acct',
        label: 'Delete Acct',
        fieldset: CONTACT_FORM_STATES.COLLECTING_ORDER_DATA
      },
      {
        value: 'Ordering Issue',
        label: 'Ordering Issue',
        fieldset: CONTACT_FORM_STATES.COLLECTING_ORDER_DATA
      },
      {
        value: 'Points did not show up',
        label: 'Points did not show up',
        fieldset: CONTACT_FORM_STATES.COLLECTING_ORDER_DATA
      },
      {
        value: 'Website/Tech issue',
        label: 'Website/Tech issue',
        fieldset: CONTACT_FORM_STATES.COLLECTING_ORDER_DATA
      },
      {
        value: 'Other',
        label: 'Other',
        fieldset: CONTACT_FORM_STATES.COLLECTING_ORDER_DATA
      }
    ],
    required: true
  },
  {
    name: 'orderMethod',
    label: 'How did you order?',
    type: SupportedFormItems.SELECT,
    options: [
      {
        value: ONLINE_CARRYOUT_OPTION_VALUE,
        label: 'Online Carryout',
        fieldset: CONTACT_FORM_STATES.COLLECTING_ORDER_DATA
      },
      {
        value: ONLINE_DELIVERY_OPTION_VALUE,
        label: 'Online Delivery',
        fieldset: CONTACT_FORM_STATES.COLLECTING_ORDER_DATA
      },
      {
        value: 'Call in Carryout',
        label: 'Call in Carryout',
        fieldset: CONTACT_FORM_STATES.COLLECTING_ORDER_DATA
      },
      {
        value: 'Call in Delivery',
        label: 'Call in Delivery',
        fieldset: CONTACT_FORM_STATES.COLLECTING_ORDER_DATA
      },
      {
        value: 'In-store / Walk-in',
        label: 'In-store / Walk-in',
        fieldset: CONTACT_FORM_STATES.COLLECTING_ORDER_DATA
      },
      {
        value: 'Dine-in',
        label: 'Dine-in',
        fieldset: CONTACT_FORM_STATES.COLLECTING_ORDER_DATA
      },
      {
        value: 'Drive-thru',
        label: 'Drive-thru',
        fieldset: CONTACT_FORM_STATES.COLLECTING_ORDER_DATA
      },
      {
        value: 'General Inquiry',
        label: 'General Inquiry',
        fieldset: CONTACT_FORM_STATES.COLLECTING_GENERAL_INQUIRY
      }
    ],
    required: true
  },
  {
    name: 'deviceUsed',
    label: 'What device did you use?',
    type: SupportedFormItems.SELECT,
    options: [
      {
        value: 'Mobile Website',
        label: 'Mobile Website'
      },
      {
        value: 'iPhone App',
        label: 'iPhone App'
      },
      {
        value: 'Android App',
        label: 'Android App'
      },
      {
        value: 'Desktop Website',
        label: 'Desktop Website'
      },
      {
        value: 'iPad App',
        label: 'iPad App'
      }
    ],
    required: true
  },
  {
    name: 'orderDate',
    label: 'Date',
    type: SupportedFormItems.DATE_PICKER,
    nextTo: 'orderTime',
    inputMode: 'date',
    required: true
  },
  {
    name: 'orderTime',
    label: 'Time',
    type: SupportedFormItems.SELECT,
    options: [
      {
        value: 'Lunch (Before 2pm)',
        label: 'Lunch (Before 2pm)'
      },
      {
        value: 'Midday (2pm-5pm)',
        label: 'Midday (2pm-5pm)'
      },
      {
        value: 'Dinner (5pm-8pm)',
        label: 'Dinner (5pm-8pm)'
      },
      {
        value: 'Late Night (After 8pm)',
        label: 'Late Night (After 8pm)'
      }
    ],
    required: true
  },
  {
    name: 'storeLocation',
    label: 'Store Location',
    type: SupportedFormItems.SELECT,
    options: [
      {
        value: 'Select store',
        label: 'Select store'
      }
    ],
    required: false
  },
  {
    name: 'amountSpent',
    label: 'Amount Spent',
    type: SupportedFormItems.INPUT,
    inputMode: 'decimal',
    required: true,
    startAdornment: '$',
    pattern: SPENT_AMOUNT_PATTERN
  },
  {
    name: 'sharedFeedback',
    label: 'What would you like to share with us?',
    type: SupportedFormItems.TEXTAREA,
    maxLength: 1000,
    showCharacterCount: true,
    multiline: true,
    minRows: 7,
    required: true
  },
  {
    name: 'responseMethod',
    label: 'How would you like us to get back to you?',
    type: SupportedFormItems.SELECT,
    options: [
      {
        value: RESPONSE_METHODS.EMAIL,
        label: RESPONSE_METHODS.EMAIL,
        fieldset: CONTACT_FORM_STATES.COLLECTING_CONTACT_INFORMATION
      },
      {
        value: RESPONSE_METHODS.PHONE,
        label: RESPONSE_METHODS.PHONE,
        fieldset: CONTACT_FORM_STATES.COLLECTING_CONTACT_INFORMATION
      },
      {
        value: RESPONSE_METHODS.NO_REPLY_NEEDED,
        label: RESPONSE_METHODS.NO_REPLY_NEEDED,
        fieldset: CONTACT_FORM_STATES.COLLECTING_CONTACT_INFORMATION
      }
    ]
  },
  {
    name: 'firstName',
    label: 'First name',
    type: SupportedFormItems.INPUT,
    inputMode: 'text',
    nextTo: 'lastName',
    extraInformation: {
      text: 'Any information you submit via the Contact Us page will be treated in accordance with Pizza Hut\'s _pizza_hut_privacy_link_. We may use the information you provide to contact you about your submission.',
      title: 'Your info',
      links: [
        {
          pattern: '_pizza_hut_privacy_link_',
          label: 'Privacy Policy',
          url: '/privacy-policy',
          external: true
        }
      ]
    },
    required: true
  },
  {
    name: 'lastName',
    label: 'Last name',
    type: SupportedFormItems.INPUT,
    inputMode: 'text',
    required: true
  },
  {
    name: 'email',
    label: 'Email',
    type: SupportedFormItems.INPUT,
    inputMode: 'email',
    nextTo: 'confirmEmail',
    required: true,
    pattern: EMAIL_PATTERN
  },
  {
    name: 'confirmEmail',
    label: 'Confirm email',
    type: SupportedFormItems.INPUT,
    inputMode: 'email',
    required: true,
    pattern: EMAIL_PATTERN
  },
  {
    name: 'phone',
    label: 'Phone',
    type: SupportedFormItems.INPUT,
    inputMode: 'tel',
    required: true,
    pattern: PHONE_PATTERN
  }
] as ContactFormField[];
